export default __webpack_public_path__ + "static/media/star.c0fac6b6.svg";